import { RouteComponentProps } from 'react-router-dom';
import WidgetBuilder from './WidgetBuilder';

interface Props extends RouteComponentProps<{ id: string }> {}
const ChartBuilderPage = (props: Props) => {
    return <WidgetBuilder chartIdToLoad={props.match.params.id} />;
};

export default ChartBuilderPage;
